export const Cyclostratigraphy = [
    { prop: 'id', label: 'ID' },
    { label: 'Section Or Borehole', prop: 'section_Or_Borehole' },
    { prop: 'latitude', label: 'Latitude' },
    { prop: 'longitude', label: 'Longitude' },
    { prop: 'paleolatitude', label: 'Paleolatitude' },
    { prop: 'paleolongitude', label: 'Paleolongitude' },
    { prop: 'country', label: 'Country' },
    { prop: 'province', label: 'Province' },
    { prop: 'formation', label: 'Formation' },
    { prop: 'epoch', label: 'Epoch' },
    { prop: 'stage', label: 'Stage' },
    { prop: 'event', label: 'Event' },
    { prop: 'top_Depth', label: 'Top_Depth (m)' },
    { prop: 'bot_Depth', label: 'Bot_Depth (m)' },
    { prop: 'thickness', label: 'Thickness' },
    { prop: 'lithology', label: 'Lithology' },
    {
        prop: 'sedimentary_facies',
        label: 'Sedimentary facies',
    },
    {
        prop: 'sedimentary_subfacies',
        label: 'Sedimentary subfacies',
    },
    {
        prop: 'proxy_cyclostratigraphic_analysis',
        label: 'Proxy (cyclostratigraphic analysis)',
    },
    { prop: 'detrending_method', label: 'Detrending method' },
    { prop: 'spectrum_analysis_method', label: 'Spectrum analysis method' },
    { prop: 'sedimentation_rate_detection_method', label: 'Sedimentation rate detection method' },
    { prop: 'Sedimentation_rate', label: 'Sedimentation rate (cm/kyr)' },
    { prop: 'tuned_main_Cycle', label: 'Tuned main Cycle (kyr)' },
    { prop: 'fats', label: 'FATS (kyr)' },
    { prop: 'anchor_point_depth', label: 'Anchor point depth (m)' },
    { prop: 'anchor_age_type', label: 'Anchor age type' },
    { prop: 'anchor_age', label: 'Anchor age (Ma)' },
    { prop: 'ats', label: 'ATS (Ma)' },
    { prop: 'year', label: 'Year' },
    { prop: 'reference', label: 'Reference' },
    { prop: 'doi', label: 'DOI' },
    { prop: 'comments', label: 'Comments' },
    { prop: 'processed_By', label: 'Processed_By' },
    { prop: 'reviewed_By', label: 'Reviewed_By' },

];
